var Signal;

Signal = require('../signal');

module.exports = function(pred) {
  var signal;
  signal = this;
  return new Signal(function(send) {
    return signal.subscribe(function(val) {
      if (pred(val)) {
        send(val);
      }
    });
  });
};
